export const styles = {
  chip: {
    height: 20,
    mt: 1,
    span: { px: 0.5, py: 0.25 },
    borderRadius: 1,
  },
};
